// Gestion de la sécurité de session côté client :
// - configuration du timeout d'inactivité (surchargeable QA)
// - synchronisation multi-onglets (BroadcastChannel + fallback storage)
// - mémorisation du motif de déconnexion pour l'afficher au login
// Aucun token n'est stocké ici (le JWT reste dans un cookie HttpOnly).

const CH_NAME = "boomerang_session";
const EVT_KEY = "boomerang:session_evt";
export const LOGOUT_REASON_KEY = "boomerang:logout_reason";

// Timeout d'inactivité (30 min) + préavis (2 min => avertissement à 28 min).
// Surcharge possible via env (REACT_APP_IDLE_MINUTES / REACT_APP_IDLE_WARN_MINUTES)
// ou à chaud via window.__BOOMERANG_IDLE__ = { idleMs, warnMs } (utilisé en QA).
export function getIdleConfig() {
  const ov = (typeof window !== "undefined" && window.__BOOMERANG_IDLE__) || {};
  const envIdle = Number(process.env.REACT_APP_IDLE_MINUTES);
  const envWarn = Number(process.env.REACT_APP_IDLE_WARN_MINUTES);
  const idleMs =
    typeof ov.idleMs === "number" ? ov.idleMs
    : Number.isFinite(envIdle) && envIdle > 0 ? envIdle * 60000
    : 30 * 60000;
  const warnMs =
    typeof ov.warnMs === "number" ? ov.warnMs
    : Number.isFinite(envWarn) && envWarn > 0 ? envWarn * 60000
    : 2 * 60000;
  return { idleMs, warnMs };
}

let _channel = null;
export function sessionChannel() {
  if (_channel) return _channel;
  if (typeof window !== "undefined" && "BroadcastChannel" in window) {
    _channel = new BroadcastChannel(CH_NAME);
  }
  return _channel;
}

export function broadcastSession(msg) {
  const ch = sessionChannel();
  if (ch) { try { ch.postMessage(msg); } catch { /* noop */ } }
  // Fallback pour navigateurs sans BroadcastChannel : déclenche l'event "storage"
  // dans les AUTRES onglets uniquement.
  try { localStorage.setItem(EVT_KEY, JSON.stringify({ ...msg, _t: Date.now() })); } catch { /* noop */ }
}

export function onSessionStorage(handler) {
  const fn = (e) => {
    if (e.key === EVT_KEY && e.newValue) {
      try { handler({ data: JSON.parse(e.newValue) }); } catch { /* noop */ }
    }
  };
  window.addEventListener("storage", fn);
  return () => window.removeEventListener("storage", fn);
}

export function setLogoutReason(reason) {
  try { if (reason) sessionStorage.setItem(LOGOUT_REASON_KEY, reason); } catch { /* noop */ }
}

export function takeLogoutReason() {
  try {
    const r = sessionStorage.getItem(LOGOUT_REASON_KEY);
    if (r) sessionStorage.removeItem(LOGOUT_REASON_KEY);
    return r;
  } catch { return null; }
}
